import React from 'react'
import { Button, PlusIcon, color, spacer, fontWeight } from 'stylist'
import styled from '@emotion/styled'

const Plus = styled(PlusIcon)`
  border: 1px solid;
  border-radius: ${spacer(2)};
  margin-right: ${spacer(2)};
`

const StyledButton = styled(Button)`
  ${fontWeight('regular')};
  border: 0;

  &,
  &:focus,
  &:active {
    background-color: transparent;
    color: ${color('slate')};
  }

  &:hover:not([disabled]) {
    background-color: ${color('paleGrey')};
    color: ${color('slate')};
  }
`

const AddMoreButton = React.forwardRef(({ children, ...props }, ref) => (
  <StyledButton ref={ref} type="button" kind="standard" {...props}>
    <Plus size="s" />
    {children}
  </StyledButton>
))

export default AddMoreButton



// WEBPACK FOOTER //
// ./src/components/AddMoreButton.js